<template>
  <vue-circle
    :progress="percent"
    :size="size"
    :reverse="false"
    line-cap="round"
    :fill="fill"
    :empty-fill="emptyFill"
    :animation-start-value="0.0"
    insert-mode="append"
    :thickness="5"
    :show-percent="false"
    ref="circle">
    <p class="f5-ns f7 b light-silver">{{value}}%</p>
  </vue-circle>
</template>

<script>
  import VueCircle from 'vue2-circle-progress'

  export default {
    components: {
      VueCircle
    },
    props: {
      percent: {
        required: true
      },
      size: {
        default: 75
      },
      emptyFill: {
        default: '#aaa'
      },
      fill: {
        default: function () {
          return {gradient: ['#E6007E']}
        }
      }
    },
    computed: {
      value () {
        return this.percent.toFixed(2)
      }
    },
    watch: {
      percent (newVal) {
        this.$refs.circle.updateProgress(newVal)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/CircleProgress.vue